import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createRemovePersonaFromCardCommand } from '../../../api/commands/factory/createPersonaCommands';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class RemovePersonaFromCard extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'RemovePersonaFromCard';

    public constructor(public cardId: string, public personaId: string, public shouldSendCommand = true) {
        super(RemovePersonaFromCard.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: RemovePersonaFromCard): Promise<boolean> => {
    if (action.shouldSendCommand) {
        useSendCommandAsync(action, {
            createCommand: async () => await createRemovePersonaFromCardCommand(action),
        });
    }

    return true;
};

const reducer = (state: StorymapState, action: RemovePersonaFromCard): void => {
    const card = getCardById(action.cardId);

    if (card != null) {
        if (card.personaIds.includes(action.personaId)) {
            card.personaIds = card.personaIds.filter((x) => x !== action.personaId);
        }
    }
};

//@ts-ignore
registerMiddleware(RemovePersonaFromCard.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(RemovePersonaFromCard.ACTION_TYPE, reducer);
